import React from 'react';
import PropTypes from 'prop-types';

import SEO from '../common/SEO';
import HeaderFour from '../common/header/HeaderFour';
import FooterOne from '../common/footer/FooterOne';

const LegalDocumentPage = ({ document, seo }) => {
  const { title, lastUpdated, sections } = document || {};
  const pageTitle = title || (seo && seo.title) || 'Document';
  const description = seo && seo.description;

  return (
    <>
      <SEO title={pageTitle} description={description} />
      <main className="main-wrapper">
        <HeaderFour />
        <section className="section section-padding mutawir-legal">
          <div className="container">
            <div className="mutawir-legal__header">
              <h1 className="mutawir-legal__title">{title}</h1>
              {lastUpdated && <p className="mutawir-legal__meta">{lastUpdated}</p>}
            </div>
            <div className="mutawir-legal__content">
              {Array.isArray(sections) &&
                sections.map((section, index) => (
                  <article className="mutawir-legal__section" key={index}>
                    {section.heading && <h2>{section.heading}</h2>}
                    {Array.isArray(section.paragraphs) &&
                      section.paragraphs.map((paragraph, paragraphIndex) => (
                        <p key={paragraphIndex}>{paragraph}</p>
                      ))}
                    {section.list && Array.isArray(section.list.items) && (
                      <ul>
                        {section.list.items.map((item, itemIndex) => (
                          <li key={itemIndex}>{item}</li>
                        ))}
                      </ul>
                    )}
                  </article>
                ))}
            </div>
          </div>
        </section>
        <FooterOne variant="mutawir" />
      </main>
    </>
  );
};

LegalDocumentPage.propTypes = {
  document: PropTypes.shape({
    title: PropTypes.string,
    lastUpdated: PropTypes.string,
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string,
        paragraphs: PropTypes.arrayOf(PropTypes.string),
        list: PropTypes.shape({
          items: PropTypes.arrayOf(PropTypes.string)
        })
      })
    )
  }),
  seo: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string
  })
};

LegalDocumentPage.defaultProps = {
  document: undefined,
  seo: undefined
};

export default LegalDocumentPage;
